module.exports = __webpack_public_path__ + "img/logo.a477e211.png";